import { render, staticRenderFns } from "./EditDependent.vue?vue&type=template&id=6c98ae5c&scoped=true"
import script from "./EditDependent.vue?vue&type=script&lang=ts"
export * from "./EditDependent.vue?vue&type=script&lang=ts"
import style0 from "./EditDependent.vue?vue&type=style&index=0&id=6c98ae5c&prod&lang=scss&scoped=true"
import style1 from "./EditDependent.vue?vue&type=style&index=1&id=6c98ae5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c98ae5c",
  null
  
)

export default component.exports